import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
} from "@chakra-ui/react";

import ExpertB2BDataService from "../../services/ExpertB2B";

export const DeleteB2BExpertModal = ({ isOpen, onClose, id, func }: any) => {
  const deleteExpert = () => {
    ExpertB2BDataService.deleteB2BExpert(id)
      .then((response: any) => {
        func(true);
        onClose();
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Expert</ModalHeader>
        <ModalCloseButton />
        <ModalBody>Are you sure you want to delete expert?</ModalBody>

        <ModalFooter>
          <Button
            bgColor="#327171"
            color={"white"}
            mr={3}
            onClick={deleteExpert}
          >
            Delete
          </Button>
          <Button bgColor="red" color={"white"} mr={3} onClick={onClose}>
            No
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
